import React from 'react';
import { SEO } from '../components/seo/SEO';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { ServicePillars } from '../components/sections/ServicePillars';
import { Outcomes } from '../components/sections/Outcomes';
import { Button } from '../components/ui/Button';
import { ArrowRight } from 'lucide-react';
import styles from './ServicesOverview.module.css';

export const ServicesOverview: React.FC = () => {
    const { t } = useLanguage();

    const servicePages = t.servicesOverview.services;

    return (
        <div className={styles.page}>
            <SEO
                title="Services"
                description="Explore our comprehensive services in AI Automation, ERP & SAP Integration, and Enterprise Software Development."
                canonical="/services"
            />
            {/* Hero Section */}
            <section className={styles.hero}>
                <div className={styles.hero__container}>
                    <motion.h1
                        className={styles.hero__title}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.15 }}
                    >
                        {t.services.hero.title}
                    </motion.h1>
                    <motion.p
                        className={styles.hero__subtitle}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.15, delay: 0 }}
                    >
                        {t.services.hero.subtitle}
                    </motion.p>
                </div>
            </section>

            <ServicePillars />

            <section className={styles.linksSection}>
                <div className={styles.links__container}>
                    <h2 className={styles.links__title}>{t.servicesOverview.sectionTitle}</h2>
                    <div className={styles.links__grid}>
                        {servicePages.map((service) => (
                            <Link key={service.href} to={service.href} className={styles.links__card}>
                                <span className={styles.links__eyebrow}>Service</span>
                                <span className={styles.links__label}>{service.title}</span>
                            </Link>
                        ))}
                    </div>
                </div>
            </section >

            {/* Industries Section */}
            < section className={styles.linksSection} style={{ paddingTop: 0 }}>
                <div className={styles.links__container}>
                    <h2 className={styles.links__title}>{t.industries.title}</h2>
                    <div className={styles.links__grid}>
                        {t.industries.items.map((item, index) => (
                            <div key={index} className={styles.links__card}>
                                <span className={styles.links__eyebrow}>{t.industries.tag}</span>
                                <span className={styles.links__label}>{item.title}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </section >

            <Outcomes />

            {/* Final CTA */}
            <section className={styles.cta}>
                <div className={styles.cta__container}>
                    <Button variant="primary" size="lg" icon={<ArrowRight size={20} />} to="/consultation">
                        {t.services.hero.cta}
                    </Button>
                </div>
            </section>
        </div >
    );
};
